import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }

import EventItemForm from '@/components/events/EventItemForm.vue';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, Ref, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { EventsActions, EventsState } from '@/stores/events.store';
import { EventItem } from '@/models/event-item.model';
import { useEvents, Event } from '@/services/events.composable';
import TranslatedState from '../common/TranslatedState.vue';
import ListFilter from '../common/ListFilter.vue';
import eventsService from '@/services/events.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsList',
  setup(__props) {

const store = useStore<ShiftCMSState & { ev: EventsState }>();
const items = computed<EventItem[]>(() => store.state.ev.items);
const events = useEvents();

const update = () => {
  store.dispatch(EventsActions.GetEventItems);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editEventItem = (_: Event, { item }: { item: EventItem }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(EventItemForm),
    data: item,
  });
};

const addEventItem = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(EventItemForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Title', key: 'title', width: '30%' },
  { title: 'Category', key: 'mainCategory.title', width: '15%' },
  { title: 'Domain', key: 'url', width: '15%' },
  { title: 'Start', key: 'startDate', width: '15%' },
  { title: 'Added', key: 'creationDate', width: '10%' },
  { title: 'State', key: 'translated', width: '5%' },
];

const formatUrl = (url: string) => {
  const data = new URL(url);

  return data.host;
};

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<EventItem[]>(() => {
  return items.value.filter((v: EventItem) => {
    if (filterTitle.value) {
      return [
        v.title,
        v.description,
        v.startDate ? format(v.startDate, 'do MMMM - HH:mm') : '',
        format(v.creationDate, 'dd-MM-yyyy'),
      ]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;
}

async function triggerCrawl(isActive: Ref) {
  store.dispatch(Actions.ShowNotification, {
    message: 'Crawling sources',
    type: 'info',
  });

  isActive.value = false;
  const result = await eventsService.trigger();

  store.dispatch(Actions.ShowNotification, {
    message: `Added ${result.totalInserted} events from ${result.totalSources} sources`,
    type: 'info',
  });
}

async function triggerCrawlAndUpdate(isActive: Ref) {
  store.dispatch(Actions.ShowNotification, {
    message: 'Crawling sources',
    type: 'info',
  });

  isActive.value = false;
  const result = await eventsService.trigger(true);

  store.dispatch(Actions.ShowNotification, {
    message: `Added ${result.totalInserted} events from ${result.totalSources} sources`,
    type: 'info',
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Event Items", -1)),
      _createVNode(_component_v_btn, {
        type: "button",
        color: "warning",
        onClick: triggerCrawl,
        style: {"position":"absolute","top":"70px","right":"60px","z-index":"1"}
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Find more events")
        ])),
        _: 1
      }),
      _createVNode(_component_v_dialog, { width: "auto" }, {
        activator: _withCtx(({ props: activatorProps }) => [
          _createVNode(_component_v_btn, _mergeProps({
            type: "button",
            color: "warning"
          }, activatorProps, { style: {"position":"absolute","top":"70px","right":"60px","z-index":"1"} }), {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Find more events")
            ])),
            _: 2
          }, 1040)
        ]),
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Crawl the internet for more events", -1)),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            color: "success",
                            type: "button",
                            block: "",
                            onClick: () => triggerCrawl(isActive)
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("Find new events")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            color: "warning",
                            type: "button",
                            block: "",
                            onClick: () => triggerCrawlAndUpdate(isActive)
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode("Update and find new events")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      _createVNode(ListFilter, {
        dense: "",
        options: [],
        onFilter: updateFilter
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editEventItem,
        headers: headers,
        items: filteredItems.value,
        itemsPerPage: "25",
        hover: "",
        rowProps: 
        (data) => {
          return {
            class: {
              'item-published': data.item.published,
              'item-dismissed': data.item.dismissed,
            },
          };
        }
      
      }, {
        "item.startDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM - HH:mm')), 1)
        ]),
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'dd-MM-yyyy')), 1)
        ]),
        "item.url": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(formatUrl(value)), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TranslatedState, { item: item }, null, 8, ["item"]),
            _cache[5] || (_cache[5] = _createTextVNode("   ")),
            _createVNode(_component_v_tooltip, {
              text: 
              item.published
                ? 'This item is published'
                : 'This item is not published'
            
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _mergeProps(props, {
                  icon: item.published ? 'mdi-eye-check' : 'mdi-eye-outline',
                  color: item.published ? 'green' : 'red'
                }), null, 16, ["icon", "color"])
              ]),
              _: 2
            }, 1032, ["text"])
          ])
        ]),
        _: 1
      }, 8, ["items", "rowProps"]),
      _createVNode(_component_v_btn, {
        onClick: addEventItem,
        color: "success"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Add Event Item")
        ])),
        _: 1
      }),
      _cache[8] || (_cache[8] = _createTextVNode("  "))
    ]),
    _: 1
  }))
}
}

})